import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66fecbdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PreTripTransferModal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Редактировать предрейс",
    "with-cancel-button": "",
    "confirm-disabled": _ctx.state.is_loading,
    loading: _ctx.state.is_loading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_new_select, {
          placeholder: "Укажите причину",
          value: _ctx.state.commentId,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.commentId) = $event)),
          options: _ctx.comments.list,
          loading: _ctx.comments.is_loading,
          failed: _ctx.comments.is_failed,
          disabled: _ctx.comments.is_loading || _ctx.state.is_loading,
          searchable: false,
          "is-invalid": _ctx.state_form$.commentId.$error,
          "validation-errors": _ctx.state_form$.commentId.$errors,
          onChange: _ctx.onReasonChange
        }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors", "onChange"]),
        _createVNode(_component_new_input, {
          type: "date",
          placeholder: "Перенос на день",
          value: _ctx.state.date,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.date) = $event)),
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.state_form$.date.$error,
          "validation-errors": _ctx.state_form$.date.$errors,
          onChange: _ctx.onDateChange
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors", "onChange"]),
        (_ctx.state.commentId === _ctx.ISSUE_BY_LOGIST_REASON_ID || _ctx.state.commentId === _ctx.ISSUE_BY_WAREHOUSE_REASON_ID)
          ? (_openBlock(), _createBlock(_component_new_input, {
              key: 0,
              placeholder: "Комментарий логиста",
              value: _ctx.state.commentInfo,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.commentInfo) = $event)),
              disabled: _ctx.state.is_loading,
              "is-invalid": _ctx.state_form$.commentInfo.$error,
              "validation-errors": _ctx.state_form$.commentInfo.$errors
            }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]))
          : _createCommentVNode("", true),
        (_ctx.state.commentId === _ctx.EARLY_SEND_REASON_ID)
          ? (_openBlock(), _createBlock(_component_new_select, {
              key: 1,
              placeholder: "Укажите рейс",
              label: "tripNumber",
              value: _ctx.state.tripId,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.tripId) = $event)),
              options: _ctx.trips.list,
              loading: _ctx.trips.is_loading,
              failed: _ctx.trips.is_failed,
              disabled: _ctx.trips.is_loading || _ctx.state.is_loading,
              searchable: false,
              "is-invalid": _ctx.state_form$.tripId.$error,
              "validation-errors": _ctx.state_form$.tripId.$errors
            }, {
              "selected-option": _withCtx(({ option }) => [
                _createTextVNode(_toDisplayString(option.tripNumber) + " (" + _toDisplayString(option.fromCity.name) + " - " + _toDisplayString(option.toCity.name) + ") ", 1)
              ]),
              option: _withCtx(({ option }) => [
                _createTextVNode(_toDisplayString(option.tripNumber) + " (" + _toDisplayString(option.fromCity.name) + " - " + _toDisplayString(option.toCity.name) + ") ", 1)
              ]),
              _: 1
            }, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["confirm-disabled", "loading", "onSubmit", "onCancel"]))
}